import { render, staticRenderFns } from "./splitEmail.vue?vue&type=template&id=4957b248&scoped=true"
import script from "./splitEmail.vue?vue&type=script&lang=js"
export * from "./splitEmail.vue?vue&type=script&lang=js"
import style0 from "./splitEmail.vue?vue&type=style&index=0&id=4957b248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4957b248",
  null
  
)

export default component.exports